import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  headersSetores,
  SetoresTableRow,
  valoresOffcanvas,
} from './auxiliarSetorDaf';
import BarraInferiorBotoes from '../../../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../../../components/BarraSubAbas';
import ContainerConteudo from '../../../../../components/ContainerConteudo';
import DetailsTable from '../../../../../components/CustomTable/DetailsTable';
import { TableDetailsRow } from '../../../../../components/CustomTable/types/table.type';
import CustomTableOffcanvas from '../../../../../components/CustomTableOffcanvas';
import WorkspaceBotoes from '../../../../../components/WorkspaceBotoes';
import { getUser } from '../../../../../modules/contexts/Auth/RequireAuth';
import { useSelect } from '../../../../../modules/contexts/Select/useSelect';
import { getAllSetoresDaf } from '../../../../../services/setoresDaf/setoresDafService';
import theme from '../../../../../theme';
import { useExcelExport } from '../../../../../utils/excel-export';
import {
  formataNomeMeioSiglas,
  formatDate,
  formatDateSimp,
  formatDateToFile,
} from '../../../../../utils/functions';
import { getSubAbas } from '../../subabas';

const SetorDafListagem: React.FC = () => {
  const navigate = useNavigate();
  const user = getUser();
  const userID = user.sub;
  const [data, setData] = useState<any[]>([]);

  const { getSelectDominioPai } = useSelect();
  const componentesAf = getSelectDominioPai(1);

  const fetchData = async () => {
    try {
      const registros = await getAllSetoresDaf();
      setData(registros);
    } catch (error: any) {
      console.error('Erro ao buscar Setores DAF:', error);
    }
  };
  // Buscar dados
  useEffect(() => {
    fetchData();
  }, []);

  // TABELA E OFFCANVAS
  const tableData: SetoresTableRow[] = data.map((item) => {
    return {
      id: item.id,
      status: item.status === 1,
      componenteAf:
        item.restricaoComponenteAf === 1
          ? componentesAf.find((comp) => comp.value === item.componenteAfId)
              ?.label || 'Não informado'
          : 'Sem Restrição',
      nomeSetorDaf: item.nomeSetorDaf,
      sigla: item.sigla,
      dataCriacao: formatDateSimp(item.dataCriacao),
      dataExtincao: item.dataExtincao ? formatDateSimp(item.dataExtincao) : '-',
    };
  });

  const offCanvasData: TableDetailsRow[] = data.map((item) => {
    let statusLabel = '';
    let statusBackgroundColor = '';

    if (item.status === 1) {
      statusLabel = 'Ativo';
      statusBackgroundColor = theme.colors.verde;
    } else if (item.status === 2) {
      statusLabel = 'Inativo';
      statusBackgroundColor = theme.colors.vermelho;
    } else {
      statusLabel = 'Não informado';
      statusBackgroundColor = 'grey';
    }

    return {
      id: item.id,

      dataRegistro:
        formatDate(item.dataRegistro) +
        ' - ' +
        formataNomeMeioSiglas(item.usuarioRegistro.nomeCompleto),

      dataUltimaAtualizacao:
        formatDate(item.dataUltimaAtualizacao) +
        ' - ' +
        formataNomeMeioSiglas(item.usuarioAtualizacao.nomeCompleto),

      dataUltimaVisualizacao:
        formatDate(item.dataUltimaVisualizacao) +
        ' - ' +
        formataNomeMeioSiglas(item.usuarioUltimaVisualizacao.nomeCompleto),

      nEdicoes: item.nEdicoes,
      nVisualizacoes: item.nVisualizacoes,
      nVisualizadores: item.nVisualizadores,

      separadorLog: '',

      // ⭐ AQUI — o status vira JSX, igual ao seu modelo anterior
      status: (
        <div
          style={{
            textAlign: 'left',
            justifySelf: 'flex-start',
            marginLeft: '0px',
          }}
        >
          <span
            style={{
              backgroundColor: statusBackgroundColor,
              borderRadius: '5px',
              padding: '5px 10px',
              color: 'white',
              display: 'inline-block',
              minWidth: '50px',
            }}
          >
            {statusLabel}
          </span>
        </div>
      ),

      restricaoComponenteAf:
        item.restricaoComponenteAf === 1
          ? (componentesAf.find((c) => c.value === item.componenteAfId)
              ?.label ?? 'Não informado')
          : 'Sem Restrição',

      nomeSetorDaf: (
        <span
          style={{
            fontWeight: 'bold',
            borderRadius: '4px',
            borderColor: '#ccc',
            padding: '5px 10px',
            backgroundColor: '#cecece',
          }}
        >
          {item.nomeSetorDaf.toUpperCase()}
        </span>
      ),

      sigla: item.sigla,

      dataCriacao: formatDateSimp(item.dataCriacao),
      dataExtincao: item.dataExtincao ? formatDateSimp(item.dataExtincao) : '-',

      separadorObservacoes: '',
      observacoes: item.observacoes,
    };
  });

  const handleClickInserir = () => {
    navigate('setor/dadosgerais');
  };

  const { exportData, isExporting } = useExcelExport('listagemcores');
  const handleExport = async () => {
    try {
      await exportData(
        data,
        `sisaf_setoresdaf_${formatDateToFile(new Date().toISOString())}.xlsx`,
        userID,
        'Listagem de Setores DAF',
        'DAF',
      );
    } catch (error) {
      console.error('Erro na exportação:', error);
    }
  };

  const [selectedDetailsRowId, setSelectedDetailsRowId] = useState<
    string | number | null
  >(null);

  const handleTableRowClick = (row: SetoresTableRow) => {
    if (row?.id) {
      navigate(`setor/${row.id}/dadosgerais`);
    }
  };

  const handleOpenDetails = (row: SetoresTableRow) => {
    if (!row?.id) return;
    setSelectedDetailsRowId(row.id);
  };

  const offcanvasOpenRoute = useMemo(() => {
    if (typeof window === 'undefined') return undefined;
    if (!selectedDetailsRowId) return undefined;
    const fichaPath = `/ficha/${selectedDetailsRowId}/dadosgerais`;
    return `${window.location.origin}/#${location.pathname}${fichaPath}`;
  }, [selectedDetailsRowId, location.pathname]);

  return (
    <>
      <BarraSubAbas subAbas={getSubAbas()} />

      {/* <ContainerConteudo>
        <Tabela
          headers={headersTable}
          dataTable={tableData}
          dataOffCanvas={offCanvasData}
          displayValues={valoresOffcanvas}
          tituloCanvas="Cor"
          resultRow={true}
          onRowClick={(row: any) => {
            const id = row.id;
            window.location.href = `#/daf/adm/setores/setor/${id}/dadosgerais`;
          }}
          onAbrirOffCanvasClick={(row: any) => {
            const id = row.id;
            window.location.href = `#/daf/adm/setores/setor/${id}/dadosgerais`;
          }}
        />
      </ContainerConteudo> */}

      <ContainerConteudo>
        <CustomTableOffcanvas
          headers={headersSetores}
          data={tableData}
          displayValues={valoresOffcanvas}
          offcanvasTitle="teste"
          widthOffcanvas="60%"
          openRoute={offcanvasOpenRoute}
          onOpenOffcanvas={handleOpenDetails}
          onRowClick={handleTableRowClick}
          itemsPerPage={50}
          emptyMessage="teste"
          filterable={false}
          showPagination={false}
          showOpenButton={true}
        >
          {(row) => (
            <DetailsTable
              rows={offCanvasData}
              selectedId={row?.id ?? selectedDetailsRowId}
              displayValues={valoresOffcanvas}
            />
          )}
        </CustomTableOffcanvas>
      </ContainerConteudo>

      <BarraInferiorBotoes>
        <WorkspaceBotoes
          inserir
          onClickInserir={handleClickInserir}
          download
          onClickDownload={handleExport}
        />
      </BarraInferiorBotoes>
    </>
  );
};

export default SetorDafListagem;
